import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { registerUserRequest, guestUser, loginUserRequest } from '../../redux/actions/authenticationActions'; // import the actions
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { setCheckout } from '../../lib/helper.js';
import { updateOrderIdDetails } from '../dashboard/actions';
import { browserHistory } from 'react-router';
import { dashboardData, getDataName } from '../dashboard/reducer';
import { validateAddressInputs } from '../../lib/validator';
import UserAddressFields from '../myaccount/UserAddressFields';
import defaultMsg from '../../translations/lang/en-US.json';

//creating a Component  using the class
class Register extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      telephoneNumber: '',
      passwordNote: false,
      isValidPassword: -1,
      isConfirmPassword: -1,
      isValidNumber: true,
      isValidEmail: true,
      isValidFirstName: true,
      isValidLastName: true,
      addressDetails: {},
    };

    // binding the functions with the this
    this.handleRegister = this.handleRegister.bind(this);
    this.enablePasswordNote = this.enablePasswordNote.bind(this);
    this.disablePasswordNote = this.disablePasswordNote.bind(this);
    this.isValidPassword = this.isValidPassword.bind(this);
    this.confirmPassword = this.confirmPassword.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(
      this
    );
    this.isConfirmed = this.isConfirmed.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.isValidPhoneNumber = this.isValidPhoneNumber.bind(this);
    this.onFocusPhoneNumber = this.onFocusPhoneNumber.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.handleFirstName = this.handleFirstName.bind(this);
    this.handleLastName = this.handleLastName.bind(this);
    this.validateFirstName = this.validateFirstName.bind(this);
    this.validateLastName = this.validateLastName.bind(this);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.isValidUserAddress = this.isValidUserAddress.bind(this);
  }

  handleAddressChange(addressDetails) {
    this.setState({ addressDetails });
  }

  handleFirstName() {
    this.setState({
      isValidFirstName: true,
    });
  }

  handleLastName() {
    this.setState({
      isValidLastName: true,
    });
  }

  isValidName(text) {
    return /^[A-Za-z\s]+$/.test(text);
  }

  validateFirstName() {
    this.setState({
      isValidFirstName: this.isValidName(
        ReactDOM.findDOMNode(this.refs.firstName).value
      ),
    });
  }

  validateLastName() {
    this.setState({
      isValidLastName: this.isValidName(
        ReactDOM.findDOMNode(this.refs.lastName).value
      ),
    });
  }

  //Onchange handler  for the each input box
  handleEmailChange(e) {
    this.setState({
      email: e.target.value,
      isValidEmail: true,
    });
  }

  validateEmail() {
    this.setState({
      isValidEmail: this.isValidEmail(),
    });
  }

  isValidEmail() {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
      this.state.email
    );
  }

  validatePhoneNumber() {
    this.setState({
      isValidNumber: this.isValidPhoneNumber(),
    });
  }

  onFocusPhoneNumber() {
    this.setState({
      isValidNumber: true,
    });
  }

  validatePassword() {
    this.setState({
      isConfirmPassword: this.isConfirmed(),
    });
  }

  confirmPassword() {
    if (!this.isValidPassword()) {
      this.setState({
        isValidPassword: false,
        passwordNote: true,
      });
    } else {
      this.setState({
        isValidPassword: true,
        passwordNote: false,
      });
    }
  }

  handlePasswordChange(e) {
    this.setState({
      password: e.target.value,
      isValidPassword: this.isValidPassword(),
      isConfirmPassword: -1,
    });
  }

  handleConfirmPasswordChange(e) {
    const value = e.target.value;
    this.setState({
      confirmPassword: value,
      isConfirmPassword: this.isConfirmed(value),
    });
  }

  isValidPassword() {
    return /^(?=.*\d)(?=.*[@#\-_$%^&+=Â§!\?])(?=.*[a-z])(?=.*[A-Z])[0-9A-Za-z@_!-]{8,15}$/.test(
      this.state.password
    );
  }

  isConfirmed(value) {
    const confirmationPassword = value ? value : this.state.confirmPassword;
    return (
      this.state.password.length > 0 &&
      this.state.password === confirmationPassword
    );
  }

  isValidPhoneNumber() {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (ReactDOM.findDOMNode(this.refs.telephoneNumber).value.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  }

  enablePasswordNote() {
    this.setState({
      passwordNote: true,
      isConfirmPassword: -1,
    });
  }

  disablePasswordNote() {
    if (this.state.isValidPassword) {
      this.setState({
        passwordNote: false,
        isValidPassword: this.isValidPassword(),
      });
    } else {
      this.setState({
        passwordNote: true,
        isValidPassword: false,
      });
    }
  }

  handleGuest() {
    this.props.dispatch(guestUser());
    this.props.hideModal();
  }

  // validate user address details
  isValidUserAddress() {
    const {
      streetAddress = '',
      apartmentOrBuildingDetails = '',
      addressName = '',
      zipCode = '',
      city = '',
      state = '',
    } = this.state.addressDetails;
    if (!validateAddressInputs(addressName, 'addressName', true)) {
      this.setState(
        Object.assign({}, this.state.addressDetails, {
          isValidAddressName: false,
        })
      );
      this.props.intl.formatMessage({
        id: 'errorAddressName',
        defaultMessage: defaultMsg.errorAddressName,
      });
      return false;
    } else if (!validateAddressInputs(streetAddress, 'streetAddress', true)) {
      this.setState(
        Object.assign({}, this.state.addressDetails, {
          isValidStreetAddress: false,
        })
      );
      this.props.intl.formatMessage({
        id: 'errorStreetAddress',
        defaultMessage: defaultMsg.errorStreetAddress,
      });
      return false;
    } else if (
      !validateAddressInputs(
        apartmentOrBuildingDetails,
        'apartmentOrBuildingDetails',
        true
      )
    ) {
      this.setState(
        Object.assign({}, this.state.addressDetails, {
          isValidApartmentOrBuildingDetails: false,
        })
      );
      this.props.intl.formatMessage({
        id: 'errorApartmentOrBuildingAddress',
        defaultMessage: defaultMsg.errorApartmentOrBuildingAddress,
      });
      return false;
    } else if (!validateAddressInputs(city, 'city', true)) {
      this.setState(
        Object.assign({}, this.state.addressDetails, {
          isValidCity: false,
        })
      );
      this.props.intl.formatMessage({
        id: 'errorTownOrCity',
        defaultMessage: defaultMsg.errorTownOrCity,
      });
      return false;
    } else if (!validateAddressInputs(state, 'state', true)) {
      this.setState(
        Object.assign({}, this.state.addressDetails, {
          isValidState: false,
        })
      );
      this.props.intl.formatMessage({
        id: 'errorStateOrProvince',
        defaultMessage: defaultMsg.errorStateOrProvince,
      });
      return false;
    } else if (!validateAddressInputs(zipCode, 'zipCode', true)) {
      this.setState(
        Object.assign({}, this.state.addressDetails, {
          isValidZipCode: false,
        })
      );
      this.props.intl.formatMessage({
        id: 'errorZipCodeOrPostalCode',
        defaultMessage: defaultMsg.errorZipCodeOrPostalCode,
      });
      return false;
    } else {
      return true;
    }
  }

  // handle the Register with event
  handleRegister(event) {
    let email = ReactDOM.findDOMNode(this.refs.email).value;
    let firstName = ReactDOM.findDOMNode(this.refs.firstName).value;
    let lastName = ReactDOM.findDOMNode(this.refs.lastName).value;
    let telephoneNumber = ReactDOM.findDOMNode(this.refs.telephoneNumber).value;

    if (!this.isValidName(firstName)) {
      this.setState({
        isValidFirstName: false,
      });
      this.props.intl.formatMessage({
        id: 'errorFirstName',
        defaultMessage: defaultMsg.errorFirstName,
      });
    } else if (!this.isValidName(lastName)) {
      this.setState({
        isValidLastName: false,
      });
      this.props.intl.formatMessage({
        id: 'errorLastName',
        defaultMessage: defaultMsg.errorLastName,
      });
    } else if (telephoneNumber === '' || !this.isValidPhoneNumber()) {
      this.setState({
        isValidNumber: false,
      });
      this.props.intl.formatMessage({
        id: 'errorTelephoneNumber',
        defaultMessage: defaultMsg.errorTelephoneNumber,
      });
    } else if (
      ReactDOM.findDOMNode(this.refs.email).value === '' ||
      !this.isValidEmail()
    ) {
      this.setState({
        isValidEmail: false,
      });
      this.props.intl.formatMessage({
        id: 'errorEmailAddress',
        defaultMessage: defaultMsg.errorEmailAddress,
      });
    } else if (
      ReactDOM.findDOMNode(this.refs.password).value === '' ||
      !this.isValidPassword()
    ) {
      this.setState({
        confirmPassword: '',
        isValidPassword: false,
        passwordNote: true,
        isConfirmPassword: -1,
      });
      this.props.intl.formatMessage({
        id: 'errorPasswordCannotBeEmpty',
        defaultMessage: defaultMsg.errorPasswordCannotBeEmpty,
      });
    } else {
      if (
        ReactDOM.findDOMNode(this.refs.password).value !==
        ReactDOM.findDOMNode(this.refs.confirmPassword).value
      ) {
        this.setState({
          isConfirmPassword: false,
        });
        this.props.intl.formatMessage({
          id: 'errorPasswordsDonotMatch',
          defaultMessage: defaultMsg.errorPasswordsDonotMatch,
        });
      } else {
        // create the  object for  dispatch to the function
        let registrationParams = Object.assign(
          {},
          {
            signinname: email,
            password: ReactDOM.findDOMNode(this.refs.password).value,
            cpwd: ReactDOM.findDOMNode(this.refs.confirmPassword).value,
            fname: ReactDOM.findDOMNode(this.refs.firstName).value,
            lname: ReactDOM.findDOMNode(this.refs.lastName).value,
            mobile: ReactDOM.findDOMNode(this.refs.telephoneNumber).value,
            email: ReactDOM.findDOMNode(this.refs.email).value,
            tokenId: this.props.tokenId,
            jwt: this.props.jwt,
          },
          this.state.addressDetails
        );
        this.props
          .dispatch(registerUserRequest(registrationParams))
          .then(res => {
            if (res.status === 'S') {
              this.props.success(res.message);
              this.afterRegister(registrationParams);
            } else {
              this.props.error(res.message);
            }
          });
      }
    }
  }

  /*
  * after register is a function that makes users auto signed-in after registration is successfull
  * and redirects to checkout page on click of goToCheckout button
  * @params object containing signinname and passwords both string
  */
  afterRegister(params) {
    let signInParams = {
      dataname: this.props.getDataName,
      signinname: params.signinname,
      password: params.password,
      tokenId: this.props.tokenId,
      jwt: this.props.jwt,
    };

    this.props.dispatch(loginUserRequest(signInParams)).then(res => {
      if (res.status === 'S') {
        if (this.props.registerCaller === 'goToCheckout') {
          setCheckout(
            this,
            true,
            function(response) {
              this.props.dispatch(updateOrderIdDetails(response));
              browserHistory.push('/' + this.props.rname + '/checkout');
            }.bind(this)
          );
        }
      } else {
        this.props.error(res.message);
      }
    });
    this.props.hideModal();
  }

  // render  all html in this  render function
  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <form
            id="register-form"
            className="form-style"
            style={{ display: 'block' }}
          >
            <div
              className={`${
                this.state.isValidFirstName === false ? 'has-error' : ''
              } form-group`}
            >
              <label className="customSignLabel control-label">
                <FormattedMessage
                  id="enterFirstName"
                  defaultMessage={defaultMsg.enterFirstName}
                />
                <mark className="mark-style"> * </mark>
              </label>
              <input
                type="firstName"
                name="firstName"
                ref="firstName"
                tabIndex="1"
                onChange={this.handleFirstName}
                onFocus={this.handleFirstName}
                onBlur={this.validateFirstName}
                className="form-control customInputBox"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterFirstName',
                  defaultMessage: defaultMsg.placeholderEnterFirstName,
                })}
              />
              {!this.state.isValidFirstName ? (
                <span
                  className="help-block no-border"
                  style={{ fontSize: '12px' }}
                >
                  <FormattedMessage
                    id="errorFirstName"
                    defaultMessage={defaultMsg.errorFirstName}
                  />
                </span>
              ) : null}
              {this.state.firstName}
            </div>
            <div
              className={`${
                this.state.isValidLastName === false ? 'has-error' : ''
              } form-group`}
            >
              <label className="customSignLabel control-label">
                <FormattedMessage
                  id="enterLastName"
                  defaultMessage={defaultMsg.enterLastName}
                />
                <mark className="mark-style"> * </mark>
              </label>
              <input
                type="lastName"
                name="lastName"
                ref="lastName"
                tabIndex="1"
                onChange={this.handleLastName}
                onFocus={this.handleLastName}
                onBlur={this.validateLastName}
                className="form-control customInputBox"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterLastName',
                  defaultMessage: defaultMsg.placeholderEnterLastName,
                })}
              />
              {!this.state.isValidLastName ? (
                <span
                  className="help-block  no-border"
                  style={{ fontSize: '12px' }}
                >
                  <FormattedMessage
                    id="errorLastName"
                    defaultMessage={defaultMsg.errorLastName}
                  />
                </span>
              ) : null}
              {this.state.lastName}
            </div>
            <div
              className={`${
                this.state.isValidNumber === false ? 'has-error' : ''
              } form-group`}
            >
              <label className="customSignLabel control-label">
                <FormattedMessage
                  id="enterTelephoneNumber"
                  defaultMessage={defaultMsg.enterTelephoneNumber}
                />
                <mark className="mark-style"> * </mark>
              </label>
              <input
                type="telephoneNumber"
                name="telephoneNumber"
                ref="telephoneNumber"
                tabIndex="1"
                onFocus={this.onFocusPhoneNumber}
                onBlur={this.validatePhoneNumber}
                className="form-control customInputBox"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterTelephoneNumber',
                  defaultMessage: defaultMsg.placeholderEnterTelephoneNumber,
                })}
              />
              {!this.state.isValidNumber ? (
                <span
                  className="help-block  no-border"
                  style={{ fontSize: '12px' }}
                >
                  <FormattedMessage
                    id="errorTelephoneNumber"
                    defaultMessage={defaultMsg.errorTelephoneNumber}
                  />
                </span>
              ) : null}
              {this.state.telephoneNumber}
            </div>
            <div
              className={`${
                this.state.isValidEmail === false ? 'has-error' : ''
              } form-group`}
            >
              <label className="customSignLabel control-label">
                <FormattedMessage
                  id="enterEmailAddress"
                  defaultMessage={defaultMsg.enterEmailAddress}
                />
                <mark className="mark-style"> * </mark>
              </label>
              <input
                type="input"
                name="email"
                ref="email"
                tabIndex="1"
                className="form-control customInputBox"
                onBlur={this.validateEmail}
                value={this.state.email}
                onChange={this.handleEmailChange}
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterEmailAddress',
                  defaultMessage: defaultMsg.placeholderEnterEmailAddress,
                })}
              />
              {!this.state.isValidEmail ? (
                <span
                  className="help-block  no-border"
                  style={{ fontSize: '12px' }}
                >
                  <FormattedMessage
                    id="errorEmailAddress"
                    defaultMessage={defaultMsg.errorEmailAddress}
                  />
                </span>
              ) : null}
            </div>
            <div
              className={`${
                this.state.isValidPassword === false ? 'has-error' : ''
              } ${
                this.state.isValidPassword === true ? 'has-success' : ''
              } form-group`}
              style={{ margin: '0px' }}
            >
              <label className="customSignLabel control-label">
                <FormattedMessage
                  id="enterPassword"
                  defaultMessage={defaultMsg.enterPassword}
                />
                <mark className="mark-style"> * </mark>
              </label>
              <input
                type="password"
                name="password"
                ref="password"
                tabIndex="2"
                value={this.state.password}
                onChange={this.handlePasswordChange}
                onFocus={this.enablePasswordNote}
                onBlur={this.disablePasswordNote}
                className="form-control customInputBox"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterPassword',
                  defaultMessage: defaultMsg.placeholderEnterPassword,
                })}
              />
              {this.state.passwordNote ? (
                <span
                  className="help-block no-border"
                  style={{ fontSize: '12px' }}
                >
                  <ul style={{ paddingLeft: '16px', margin: '0px' }}>
                    <li>
                      <FormattedMessage
                        id="errorPassword1"
                        defaultMessage={defaultMsg.errorPassword1}
                      />
                    </li>
                    <li>
                      <FormattedMessage
                        id="errorPassword2"
                        defaultMessage={defaultMsg.errorPassword2}
                      />
                    </li>
                  </ul>
                </span>
              ) : null}
            </div>
            <div
              className={`${
                this.state.isConfirmPassword === false ? 'has-error' : ''
              } ${
                this.state.isConfirmPassword === true ? 'has-success' : ''
              } form-group`}
            >
              <label className="customSignLabel control-label">
                <FormattedMessage
                  id="confirmPassword"
                  defaultMessage={defaultMsg.confirmPassword}
                />
                <mark className="mark-style"> * </mark>
              </label>
              <input
                type="password"
                name="confirm-password"
                ref="confirmPassword"
                tabIndex="2"
                value={this.state.confirmPassword}
                onChange={this.handleConfirmPasswordChange}
                onFocus={this.confirmPassword}
                onBlur={this.validatePassword}
                className="form-control customInputBox"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderConfirmPassword',
                  defaultMessage: defaultMsg.placeholderConfirmPassword,
                })}
              />

              {!this.state.isConfirmPassword ? (
                <span
                  className="help-block no-border"
                  style={{ fontSize: '12px' }}
                >
                  <FormattedMessage
                    id="errorPasswordsDonotMatch"
                    defaultMessage={defaultMsg.errorPasswordsDonotMatch}
                  />
                  <mark className="mark-style"> * </mark>
                </span>
              ) : null}
            </div>
            <UserAddressFields
              onChange={data => this.handleAddressChange(data)}
              formState={this.state.addressDetails}
              reduceLabelFont={true}
              save={true}
              optional={true}
            />
            <div className="form-group">
              <div className="row">
                <div className="col-sm-12">
                  <div className="wrapper">
                    <button
                      type="button"
                      onClick={this.handleRegister}
                      className="btn btn-default btn-style alignCenter olo-client-theme-border olo-client-theme-background olo-client-theme-color-white"
                    >
                      <FormattedMessage
                        id="register"
                        defaultMessage={defaultMsg.register}
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-sm-12 ">
                  <div className="wrapper">
                    <p className="strikeLine">
                      <span className="color-or olo-client-theme-color">
                        <FormattedMessage
                          id="or"
                          defaultMessage={defaultMsg.or}
                        />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-sm-12 ">
                  <div className="wrapper">
                    <button
                      type="button"
                      className="btn btn-default alignCenter order-btn inactive olo-client-theme-border olo-client-theme-background olo-client-theme-color-white"
                      onClick={() => this.handleGuest()}
                    >
                      <FormattedMessage
                        id="orderAsGuest"
                        defaultMessage={defaultMsg.orderAsGuest}
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    dashboardData: dashboardData(state),
    getDataName: getDataName(state),
  };
}

Register.propTypes = {
  intl: intlShape.isRequired,
};

export default connect(mapStateToProps)(injectIntl(Register)); // connting to the redux  using the connect function



// WEBPACK FOOTER //
// ./src/views/auth/Register.jsx